<template>
  <div>
    <v-form>
      <p class="mb-3">
        For the reaction
        <chemical-latex content="A->products," />
        time and concentration data were collected and tabulated. Also shown below are simplified
        sketches of the data.
      </p>

      <v-simple-table style="max-width: 193px" class="mb-6">
        <thead>
          <tr>
            <td>
              <stemble-latex content="$\text{[A] (M)}$" />
            </td>
            <td>
              <stemble-latex content="$\text{t (min)}$" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>0.0125</td>
            <td>0.00</td>
          </tr>
          <tr>
            <td>0.0068</td>
            <td>20.0</td>
          </tr>
          <tr>
            <td>0.0037</td>
            <td>40.0</td>
          </tr>
          <tr>
            <td>0.0015</td>
            <td>70.00</td>
          </tr>
        </tbody>
      </v-simple-table>

      <p class="pl-4 mb-6">
        <v-img style="max-width: 659px" :src="imageName" />
      </p>

      <p class="mb-2">a) What is the reaction order for the reaction? Please enter a number.</p>

      <calculation-input
        v-model="inputs.order"
        class="mb-5"
        prepend-text="$\text{Order:}$"
        :disabled="!allowEditing"
      />

      <p class="mb-2">b) What is the rate constant for the reaction?</p>

      <calculation-input
        v-model="inputs.rateConstant"
        class="mb-5"
        prepend-text="$\text{k:}$"
        append-text="$\text{Units not shown}$"
        :disabled="!allowEditing"
      />

      <p class="mb-n3">c) What are the units for the rate constant?</p>

      <v-radio-group v-model="inputs.units" class="ml-6 mb-0" :disabled="!allowEditing">
        <v-radio
          v-for="option in optionsShuffled"
          :key="'pt-3-' + option.value"
          class="my-1"
          :value="option.value"
          :label="option.text"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '../inputs/CalculationInput.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'UA_Quiz1Question1',
  components: {ChemicalLatex, StembleLatex, CalculationInput},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        order: null,
        rateConstant: null,
        units: null,
      },
      optionsUnits: [
        {text: '$\\text{M}^2 ~ \\text{min}^{-1}$', value: 'M2perMin'},
        {text: '$\\text{M} ~ \\text{min}^{-1}$', value: 'MperMin'},
        {text: '$\\text{min}^{-1}$', value: 'perMin'},
        {text: '$\\text{M}^{-1} ~ \\text{min}^{-1}$', value: 'perMperMin'},
        {text: '$\\text{M}^{-2} ~ \\text{min}^{-1}$', value: 'perM2perMin'},
      ],
    };
  },
  computed: {
    imageName() {
      return prefixPublicAsset('/img/assignments/kinPlots2.png');
    },
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.optionsUnits, this.seed);
    },
  },
};
</script>
